<template>
  <div v-if="room" class="parent-div">
    <!--Information of a room-->
    <div class="div1">
      <v-tooltip bottom>
        <template #activator="{ on }"
          ><button
            v-on="on"
            class="center-name-label btn neumorphism-out"
            @click="returnToCenters"
          >
            {{ room.center.name }}
          </button>
        </template>
        <span>{{ centerTooltip }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <button
            class="room-name-label btn neumorphism-out"
            @click="returnToRooms"
          >
            {{ room.name }}
          </button>
        </template>
        <span>{{ roomTooltip }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <button class="btn neumorphism-out sub-btn" v-on="on" icon>
            <sub-icon :resource="room" />
          </button>
        </template>
        <span v-if="isNotSubscribed">
          {{ $t("crudRooms.subscribeToThisRoom") }}
        </span>
        <span v-else>
          {{ $t("crudRooms.unsubscribeToThisRoom") }}
        </span>
      </v-tooltip>
    </div>
    <div class="div2">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <label class="btn neumorphism-out capacity-label" v-on="on"
            ><v-icon style="margin-right: 5px">{{
              !room.center.partialCap
                ? "mdi-account-group"
                : "mdi-arrow-collapse"
            }}</v-icon>
            <div style="display: inline-flex">
              <dynamic-text
                v-for="(part, index) in textPartsBeforeSlash"
                :key="index"
                :dynamic-part="part.dynamic"
                :static-part="part.static"
              />/
              <dynamic-text
                v-for="(part, index) in textPartsAfterSlash"
                :key="'A' + index"
                :dynamic-part="part.dynamic"
                :static-part="part.static"
              />
            </div>
          </label>
        </template>
        <span>{{
          !room.center.partialCap
            ? $t("crudCommon.tooltipFullCapacity")
            : $t("crudCommon.tooltipHalfCapacity")
        }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubIcon from "../../../admin/details/room/SubIcon.vue";
import DynamicText from "./DynamicText.vue";

export default {
  name: "details-room",
  components: {
    SubIcon,
    DynamicText,
  },
  props: {
    desksAvailable: null,
    editMode: null,
    room: null,
    centerTooltip: null,
    roomTooltip: null,
  },
  computed: {
    ...mapGetters("userModule", ["getCurrentUser"]),
    isNotSubscribed() {
      return !this.room.subscribersIds.includes(this.getCurrentUser.id);
    },
    textPartsBeforeSlash() {
      return [
        { dynamic: this.desksAvailable, static: this.$t("crudDesks.desks") },
      ];
    },
    textPartsAfterSlash() {
      return [
        {
          dynamic: this.room.fullCapacity,
          static: this.$t("crudDesks.bookable"),
        },
      ];
    },
  },
  methods: {
    ...mapActions("roomModule", ["loadRoomsWithDependents"]),
    returnToCenters() {
      this.$emit("redirectToPrevious");
    },
    returnToRooms() {
      this.$emit("rediretToPreviousPage");
    },
  },
  async mounted() {
    await this.loadRoomsWithDependents();
  },
};
</script>

<style lang="scss" scoped>
.parent-div {
  display: flex;
  justify-content: space-between;
}
.center-name-label {
  display: flex;
  align-items: center;
  user-select: none;
  border-radius: 20px 0 0 20px;
  font-weight: bold;
  font-size: 25px;
  margin: 20px;
  margin-right: 0;
}
.room-name-label {
  display: flex;
  align-items: center;
  user-select: none;
  border-radius: 0;
  font-weight: bold;
  font-size: 25px;
  margin: 20px;
  margin-left: 0;

  margin-right: 0;
}
.sub-btn {
  display: flex;
  align-items: center;
  user-select: none;
  font-weight: bold;
  font-size: 25px;
  margin: 20px;
  margin-left: 0;
  border-radius: 0 20px 20px 0;
}
.capacity-label {
  font-size: 22px;
  display: flex;
  user-select: none;
  margin: 20px;
  align-items: center;
}
.div1 {
  display: flex;
}
.div2 {
  display: flex;
}
</style>
